import { Link } from "react-router-dom";

interface ArticleCardProps {
  title: string;
  slug: string;
  category: string;
  categoryName: string;
  excerpt: string;
  image: string;
  date: string;
  readTime: string;
}

export default function ArticleCard({
  title,
  slug,
  category,
  categoryName,
  excerpt,
  image,
  date,
  readTime,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative h-48 overflow-hidden">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
            {categoryName}
          </span>
        </div>
      </div>
      <div className="p-5">
        <h3 className="text-base font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
          {title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
          {excerpt}
        </p>
        <div className="mt-4 flex items-center gap-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line w-3.5 h-3.5 flex items-center justify-center"></i>
            {date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line w-3.5 h-3.5 flex items-center justify-center"></i>
            {readTime}
          </span>
        </div>
      </div>
    </Link>
  );
}